import { render, staticRenderFns } from "./ModalProgramGroupAccount.vue?vue&type=template&id=1348d51c&scoped=true"
import script from "./ModalProgramGroupAccount.vue?vue&type=script&lang=js"
export * from "./ModalProgramGroupAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalProgramGroupAccount.vue?vue&type=style&index=0&id=1348d51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348d51c",
  null
  
)

export default component.exports